import { Injectable } from '@angular/core';
import { ICommonDropdownService } from '../ui-lib/common-dropdawn/typing/common-dropdown-service.interface';
import { CategoryService } from './category.service';
import { Params } from '@angular/router';
import { filter, map, Observable } from 'rxjs';
import { IPaginatedResponse } from '../typing/response.interface';
import { ICategory } from '../typing/category.interface';
import { ILabelValue } from '../ui-lib/common-dropdawn/typing/label-value.interface';

@Injectable({
    providedIn: 'root'
})
export class CategorySelectorService implements ICommonDropdownService {

    constructor(private categoryService: CategoryService) {
    }

    getList(query: Params): Observable<IPaginatedResponse<ILabelValue>> {
        return this.categoryService.getCategories(query).pipe(map(response => this.transformData(response)));
    }

    transformData(paginatedResponse: IPaginatedResponse<ICategory>): IPaginatedResponse<ILabelValue> {
        const transformedData = paginatedResponse.data.map(group => ({
            label: group.name,
            value: group.id,
            tooltip: this.getTooltip(group),
        }));

        return {
            ...paginatedResponse,
            data: transformedData,
        } as IPaginatedResponse<ILabelValue>;
    }

    getOptionsByValue(optionValue: number | string): Observable<ILabelValue> {
        return this.categoryService.getCategory(Number(optionValue)).pipe(
            filter(category => !!category),
            map(category => ({
                label: category.name as string,
                value: category.id as number,
                tooltip: '---',
            })),
        );
    }

    getTooltip(value: ICategory): string {
        return (value.name ? value.name : '') + (value.id ? '; id:' + value.id : '') ;
    }
}
